import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IUnmatchedOrderRepository } from '@/coreInfrastructureModule/interfaces/IUnmatchedOrderRepository';

/**
 * 未照合・差異一覧情報を一括削除するユースケース
 */
export class BulkDeleteUnmatchedOrderUseCase {
  private repository: IUnmatchedOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IUnmatchedOrderRepository) {
    this.repository = repository;
  }

  /**
   * 未照合・差異一覧情報を一括削除する
   * @param unmatchedOrderIds - 削除対象のID一覧
   * @returns 削除されたID一覧
   */
  public async execute(unmatchedOrderIds: string[]): Promise<INetworkResult<string[], IError>> {
    const request = {
      bulkDeleteUnmatchedOrderIds: unmatchedOrderIds.map((id) => ({
        unmatchedOrderId: id,
      })),
    };
    const networkResult = await this.repository.bulkDelete(request);
    switch (networkResult.status.type) {
      case 'success':
        return {
          status: {
            type: 'success',
            data: networkResult.status.data.result.deletedUnmatchedOrderIds,
          },
        };
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
